module.exports = __webpack_public_path__ + "3998975ed1744f123a65bd890bba3c4c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/public/fonts/Work_Sans/WorkSans-Light.woff
// module id = 1811
// module chunks = 1